// extracted by mini-css-extract-plugin
export default {"anttagcheckable":"Sender_anttagcheckable__IC9Pr","rightText":"Sender_rightText__r3vLQ","link":"Sender_link__s5Xo0"};